import each from "lodash/each";
import get from "lodash/get";
import { call, delay, fork, join, put, select, takeLatest } from "redux-saga/effects";
import * as API from "../../../containers/APIurls";
import apiClient from "../../../utils/apiClient";
import * as TradeInSlice from "./TradeInSlice";
import * as GlobalSlice from "../../../app/ducks/GlobalSlice";
import * as selectors from "./selectors";
import { getRetrieveCart5G } from "pages/Checkout/ducks/CheckoutSlice";

function* getSearchTradeInDevices(params) {
  yield put(TradeInSlice.setAPIError(false));
  yield put(TradeInSlice.setPageLoading(true));
  try {
    const resp = yield apiClient.post(API.TRADE_IN_DEVICE_LIST, params.payload);  
    yield put(TradeInSlice.setTradeInSearchDevices(resp?.data));
  } catch (err) {
    yield put(TradeInSlice.setAPIError(true));
  } finally {
    yield put(TradeInSlice.setPageLoading(false));
  }
}

function* validateTradeInValues(params) {
  yield put(TradeInSlice.setAPIError(false));
  yield put(TradeInSlice.setPageLoading(true));
  try {
    const resp = yield apiClient.post(API.TRADE_IN_VALUES_LIST, params.payload);  
    yield put(TradeInSlice.setValidateTradeInValues(resp?.data));
  } catch (err) {
    yield put(TradeInSlice.setAPIError(true));
  } finally {
    yield put(TradeInSlice.setPageLoading(false));
  }
}

function* validateTradeInDevice(params) {
  yield put(TradeInSlice.setAPIError(false));
  yield put(TradeInSlice.setTradeInNewPageLoading(true));
  try {
    const resp = yield apiClient.post(API.VALIDATE_TRADE_IN_NEW_DEVICE, params.payload);  
    yield put(TradeInSlice.setValidateTradeInNewDeviceIdResp(resp?.data));
  } catch (err) {
    yield put(TradeInSlice.setAPIError(err));
  } finally {
    yield put(TradeInSlice.setTradeInNewPageLoading(false));
  }
}

function* getTradeInValue(params) {
  yield put(TradeInSlice.setAPIError(false));
  yield put(TradeInSlice.setTradeInNewPageLoading(true));
  try {
    const resp = yield apiClient.post(API.GET_TRADE_IN_VALUE, params.payload);  
    yield put(TradeInSlice.setTradeInValueResp(resp?.data));
  } catch (err) {
    yield put(TradeInSlice.setAPIError(err));
  } finally {
    yield put(TradeInSlice.setTradeInNewPageLoading(false));
  }
}

function* updateCartTradeIn(params) {
  yield put(TradeInSlice.setAPIError(false));
  yield put(TradeInSlice.setTradeInNewPageLoading(true));
  try {
    const resp = yield apiClient.post(API.MOBILITY_ADD_TO_CART, params.payload);  
    yield put(TradeInSlice.setUpdateCartTradeInResp(resp?.data));
  } catch (err) {
    yield put(TradeInSlice.setAPIError(err));
  } finally {
    yield put(TradeInSlice.setTradeInNewPageLoading(false));
  }
}

function* removeTradeIn(params) {
  yield put(TradeInSlice.setAPIError(false));
  yield put(GlobalSlice.setLoading(true));
  try {
    const resp = yield apiClient.post(API.REMOVE_TRADE_IN, params.payload);  
    yield put(TradeInSlice.setRemoveTradeInResp(resp?.data));
    yield put({type:getRetrieveCart5G.type})
    yield put({ type: GlobalSlice.getSessionCart.type });
  } catch (err) {
    yield put(TradeInSlice.setAPIError(err));
  } finally {
    yield put(TradeInSlice.setTradeInNewPageLoading(false));
    yield put(GlobalSlice.setLoading(false));
  }
}

export default function* actionTradeInDevices() {
  yield takeLatest(TradeInSlice.getSearchTradeInDevices.type, getSearchTradeInDevices);
  yield takeLatest(TradeInSlice.validateTradeInDevice.type, validateTradeInDevice);
  yield takeLatest(TradeInSlice.validateTradeInValues.type, validateTradeInValues);
  yield takeLatest(TradeInSlice.getTradeInValue.type, getTradeInValue);
  yield takeLatest(TradeInSlice.updateCartTradeIn.type, updateCartTradeIn);
  yield takeLatest(TradeInSlice.removeTradeIn.type, removeTradeIn);
}
